module.exports = __webpack_public_path__ + "static/media/addntlInfo.18d25f17.jpeg";